import React from 'react';
import { Menu, Modal } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { useComment } from './CommentProvider';

export default (props) => {
  const {
    setEdit,
    editRef,
    commentRef,
    isGenesis,
    channelStatus,
    email: commenterEmail,
    threadStatus,
  } = props;
  const { editComment, selfEmail } = useComment();
  const canEdit = commenterEmail === selfEmail && !threadStatus;

  const handleClick = (e) => {
    e.domEvent.isPropagationStopped();
    const { key } = e;
    switch (key) {
      case 'edit':
        setEdit(true);
        // setCanOpenInput(false);
        // editComment('EDIT', props);
        break;
      case 'delete':
        Modal.confirm({
          onOk: () => {
            editComment('DELETE', props);
          },
          className: 'comment-delete-modal',
          icon: null,
          okText: 'Delete',
          cancelText: 'Cancel',
          content: `Do you want to delete this comment ${
            isGenesis ? `thread` : ''
          }?`,
          getContainer: commentRef.current,
        });

        break;
      case 'reopen':
        editComment('EDIT', { ...props, channelStatus: false }, true);
        break;
      default:
        break;
    }
  };
  const show = (isGenesis && channelStatus) || canEdit;

  return show ? (
    <Menu
      triggerSubMenuAction="click"
      onClick={handleClick}
      getPopupContainer={() => editRef.current}
      builtinPlacements={{
        rightTop: {
          points: ['tr', 'br'],
        },
      }}
    >
      <Menu.SubMenu title={<MoreOutlined />}>
        {isGenesis && channelStatus && (
          <Menu.Item key="reopen">Reopen</Menu.Item>
        )}
        {canEdit && <Menu.Item key="edit">Edit</Menu.Item>}
        {canEdit && <Menu.Item key="delete">Delete</Menu.Item>}
      </Menu.SubMenu>
    </Menu>
  ) : null;
};
